<template>
  <div class="pre-order-detail" v-show="rxType != 2">
    <div class="card">
      <!-- <div class="address">
        <img :src="position" alt="" style="width: 20px;height: 20px">
        {{address}}
      </div> -->
      <div class="content">
        <div class="head">
          <div class="title" v-if="isDrug">药品清单</div>
          <div class="desc" v-if="orderList.filter((item) => item.deliveryWay == 3).length">
            以下部分商品支持自提或快递，勾选自提将以自提方式配送，如需快递请您勾选快递配送。
          </div>
        </div>
        <div class="mt16">
          <goods-item v-for="(item, key) in orderList" :key="key" :goods="item" />
        </div>
      </div>
    </div>
    <div class="height84"></div>

    <footer class="fix-bottom fixed-ios">
      <div class="tips">新老包装随机发货，无功效差别，如给您带来不便，敬请谅解</div>
      <div class="fixed-button">
        <van-button type="primary" round size="middle" block @click="submit" :disabled="disabled">
          <span class="bold">提交订单</span>
        </van-button>
      </div>
    </footer>
  </div>
</template>
<script>
import { Dialog } from '@zyf2e/capui-mobile';
import goodsItem from './component/goodsItem';
import position from './component/position.png';

import jumpCenter from '@/mixins/jumpCenter';
import { mapGetters, mapActions } from 'vuex';

export default {
  components: { goodsItem },
  mixins: [jumpCenter],
  data() {
    return {
      orderList: [],
      position,
      form: {
        channel: 'MEDIC_SALE',
        addressId: '',
        latitude: '',
        longitude: '',
        rxId: ''
      },
      address: '',
      disabled: false,

      bizType: 'prescription',
      bizId: '',

      deliveryWayZhMap: {
        EXPRESS: 1,
        PICK: 2,
        ALL: 3
      },

      errorCode: '',
      errorMsg: '',
      rxType: '2'
    };
  },
  computed: {
    ...mapGetters(['mobileBinded']),
    isDrug() {
      const { isDrug } = this.$route.query;
      if (isDrug === 0 || isDrug === '0') {
        return false;
      }
      return true;
    }
  },
  mounted() {
    this.getUserInfo();
    this.init();
  },

  methods: {
    ...mapActions(['getUserInfo']),
    async init() {
      this.disabled = false;

      const { rxId, bizType = 'prescription', bizId, rxType = '1' } = this.$route.query;
      this.bizType = bizType;
      this.bizId = bizId || rxId;

      this.rxType = rxType;

      // if (bizType === 'prescription') {
      //   await this.precessRxOrderGetData(this.bizId);
      // } else {
      this.precessOtherOrderGetData();
      // }

      try {
        const { latitude, longitude } = await window.wx.getLocation();
        this.form.latitude = latitude;
        this.form.longitude = longitude;
      } catch (err) {}
    },

    async submit() {
      // const limitOrder = this.orderList.filter((item) => item.limitFlag === true);
      // if (limitOrder.length) {
      //   return Dialog.alert({
      //     title: '商品信息确认',
      //     message: `${limitOrder.map((item) => '「' + item.itemName + '」').join('')}已达购买上限，暂时无法购买`
      //   }).then(() => {
      //     // on close
      //   });
      // }
      if (this.errorCode === 'ITEM_BUY_LIMIT' && this.errorMsg) {
        return Dialog.alert({
          title: '商品信息确认',
          message: this.errorMsg
        }).then(() => {
          // on close
        });
      }

      if (!this.mobileBinded) {
        this.$router.push({ name: 'BindingMobilePage' });
        return;
      }

      if (this.bizType === 'prescription') {
        this.precessRxOrderSubmit();
      } else {
        this.precessOtherOrderSubmit();
      }
    },
    // async precessRxOrderGetData(rxId) {
    //   this.form.rxId = rxId;
    //   const {
    //     data = [],
    //     code,
    //     errorMsg
    //   } = await this.$fetch.getItemsByRxId({
    //     latitude: this.form.latitude,
    //     longitude: this.form.longitude,
    //     rxId,
    //     channel: this.channel
    //   });
    //   data.map((item) => {
    //     if (item.deliveryWay === 3) {
    //       item.chooseDeliver = this.deliveryWayZhMap.EXPRESS;
    //       // this.bizType === 'prescription' ? this.deliveryWayZhMap.PICK : this.deliveryWayZhMap.EXPRESS;
    //       item.isOrigin = false;
    //     }
    //   });
    //   this.orderList = data;
    //   if (code === 1000) {
    //     this.disabled = true;
    //     this.$toast(errorMsg);
    //   }
    // },
    async precessOtherOrderGetData() {
      try {
        let orders = [];

        const {
          data = [],
          code,
          errorMsg
        } = await this.$fetch.checkOrderItem({
          bizType: this.bizType,
          bizId: this.bizId
        });

        this.errorCode = code;
        this.errorMsg = errorMsg;

        orders = data || [];

        orders.map((item) => {
          if (item.deliveryWay === 3) {
            // 业务要求处方药默认发货方式为快递  zc、gyf
            item.chooseDeliver = this.deliveryWayZhMap.EXPRESS;
            // this.bizType === 'prescription' ? this.deliveryWayZhMap.PICK : this.deliveryWayZhMap.EXPRESS;
            item.isOrigin = false;
          }
        });
        this.orderList = orders;

        if (code === 1000 || code === '1000') {
          this.disabled = true;
          this.$toast(errorMsg);
        }
        if (code === 'LACK_OF_STOCK') {
          this.$toast(errorMsg);
        }

        if (this.rxType == 2) {
          this.submit();
        }
      } catch (e) {
        // 接口报错的情况下，中药处方订单直接返回上一页
        if (this.rxType == 2) {
          this.$router.go(-1);
        }
      }
    },
    async precessRxOrderSubmit() {
      try {
        const { addrId, address } = await this.$fetch.getDefaultAddress();
        this.form.addressId = addrId;
        this.address = address;
      } catch (err) {}
      const orders = this.orderList.map((item) => {
        return {
          itemId: item.itemId,
          itemNum: item.itemNum,
          supplierId: item.supplierId,
          deliveryWay: item.deliveryWay === 3 ? item.chooseDeliver : item.deliveryWay
        };
      });
      const params = {
        orders,
        ...this.form,
        bizType: this.bizType,
        bizId: this.bizId
      };

      this.$store.commit('order/setHasMoreCoupons', false); // 防止之前缓存了是否有优惠券
      this.$store.commit('order/setCouponInfo', {});
      this.$store.commit('order/setPreOrderParams', params);
      if (this.rxType == 2) {
        this.$router.replace({
          name: 'PlaceOrder',
          query: { ...this.$route.query }
        });
      } else {
        this.$router.push({
          name: 'PlaceOrder',
          query: { ...this.$route.query }
        });
      }
    },
    async precessOtherOrderSubmit() {
      const { bizType, bizId, ...otherQuery } = this.$route.query;
      const { code, errorMsg } = await this.$fetch.checkOrderItem({
        bizType: this.bizType,
        bizId: this.bizId
      });

      if (code === 1000 || code === '1000') {
        this.disabled = true;
        this.$toast(errorMsg);
        return;
      }
      // 反复确认限购
      if (code === 'ITEM_BUY_LIMIT' && errorMsg) {
        return Dialog.alert({
          title: '商品信息确认',
          message: errorMsg
        }).then(() => {
          // on close
        });
      }

      const orders = this.orderList.map((item) => {
        return {
          itemId: item.itemId,
          itemNum: item.itemNum,
          deliveryWay: item.deliveryWay === 3 ? item.chooseDeliver : item.deliveryWay,
          supplierId: item.supplierId
        };
      }).filter(item=>item.itemNum > 0)

      this.requestPreOrderAndJumpToPlaceOrder(
        { orders, bizType: this.bizType, bizId: this.bizId, channel: 'MEDIC_SALE' },
        otherQuery
      );
    }
  }
};
</script>

<style lang="less">
.pre-order-detail {
  width: 100%;
  min-height: 260px;
  background-position: 0% 0%;
  background: url('../thirdPay/img/bg_mall_top.png') no-repeat;
  background-size: 100vw;
  padding: 20px 12px 0;
  .card {
    .address {
      height: 66px;
      display: flex;
      align-items: center;
      width: 100%;
      color: #fff;
      font-size: 16px;
      font-weight: 500;
      // justify-content: center;
    }
    .content {
      padding: 16px 12px;
      border-radius: 8px;
      background: #fff;
      .head {
        .title {
          font-weight: 500;
          color: #262626;
          line-height: 16px;
          font-size: 16px;
        }
        .desc {
          margin-top: 12px;
          font-size: 12px;
          font-weight: 400;
          color: #8c8c8c;
          line-height: 18px;
        }
      }
    }
  }
  .height84 {
    height: 128px;
  }
  .tips {
    background: #ebf8ff;
    padding: 13px 16px;
    border-bottom: 1px solid #eee;
    color: #1e8dff;
    font-size: 12px;
    line-height: 14px;
  }
  .fix-bottom {
    width: 100%;
    background: #fff;
    .fixed-button {
      padding: 8px 16px;
    }
    // padding: 8px 16px;
  }
}
</style>